import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

export default function Instagram() {
  useEffect(() => {
    window.location.replace('https://www.instagram.com/heinedesign/');
  }, []);

  return (
    <div className="py-32 bg-black text-white min-h-screen flex items-center justify-center animate-fade-in">
      <Helmet>
        <title>Instagram – HEINE DESIGN</title>
        <meta name="description" content="Følg Heine Design på Instagram. Se vores profiler for møbeldesign og tømrerarbejde." />
      </Helmet>

      <div className="text-center space-y-6 max-w-md px-6">
        <i className="fa-brands fa-instagram text-5xl text-brand-oak animate-pulse" />
        <h1 className="text-2xl font-light tracking-widest uppercase">
          Sender dig til Instagram...
        </h1>
        <p className="text-sm text-white/60 leading-relaxed">
          Vi viderestiller dig til vores officielle Instagram-profil @heinedesign. Hvis det ikke sker automatisk, kan du klikke på knappen nedenfor.
        </p>
        <a
          href="https://www.instagram.com/heinedesign/"
          className="inline-block px-8 py-3 bg-brand-oak text-black text-xs tracking-widest uppercase font-semibold hover:bg-white transition-colors duration-300"
        >
          Gå til Instagram
        </a>
      </div>
    </div>
  );
}
